import { createSelector } from '@ngrx/store';
import { ColorRule } from 'src/app/core/dto';
import { IAppState } from '../store.dto';

export const selectSystemInfo = (state: IAppState) => state.data.SystemInfo;
export const selectSystemPreferences = (state: IAppState) =>
  state.data.collections.SystemPreferences;

/** System-level cell color rules. See `specs/color-rules.md`. */
export const selectColorRules = createSelector(
  selectSystemPreferences,
  (prefs): ColorRule[] => prefs?.colorRules ?? []
);
